import { z } from "zod";

export const updateMemberProfileSchema = z
  .object({
    displayName: z.string().max(120).optional(),
    avatarUrl: z.string().url().nullable().optional(),
    firstName: z.string().max(80).optional(),
    lastName: z.string().max(80).optional(),
    nickName: z.string().max(80).optional(),
    timezone: z.string().max(120).optional(),
  })
  .strict();
export type UpdateMemberProfileInput = z.infer<typeof updateMemberProfileSchema>;

export const updateMemberProfileResponseSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  avatarUrl: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  nickName: z.string().nullable(),
  timezone: z.string().nullable(),
  preferredCurrency: z.string().nullable(),
});
export type UpdateMemberProfileResponse = z.infer<typeof updateMemberProfileResponseSchema>;
